import { CountryCode } from './type';
import type { Country } from './type';

export const singapore: Country = {
    name: 'Singapore',
    nameFull: 'Singapore',
    code: CountryCode.SG,
    displayCode: CountryCode.SG,
    combinedDisplayCode: CountryCode.SG,
    makeMethod: 'makeSingapore',
    theme: false,
    currency: '$',
    currencyName: 'SGD',
    currencyWithCountry: 'SG$',
    maxImageSize: 20000000, // 20MB
    imageOptions: {
        maxSize: 20000000,
        fileType: ['.bmp','.png','.jpeg','.jpg']
    },
    maxGoodNumberPerClass: 100, // IP Australia only allows 100 goods per class for applications.
    paymentMethodsImageName: 'payment-options-au.png',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_SG,
    autoSelectedInForm: true,
};
